import { Route } from "@angular/router";
import { MarquageComponent } from "./marquage.component";
import { CasierRouting } from "./casier/casier-routing";
import { PorteurResolver } from "../../shared/porteur-resolver";
import { NomRouting } from "./nom/nom-routing";
import { FonctionRouting } from "./fonction/fonction-routing";

export const MarquageRouting: Route = {
  path: "marquage",
  component: MarquageComponent,
  resolve: {
    porteur: PorteurResolver
  },
  children: [
    { path: '', redirectTo: 'casier', pathMatch: 'full' },
    CasierRouting,
    NomRouting,
    FonctionRouting

  ],
  data: {
    breadcrumb: "Marquage"
  }
};
